module.exports = __webpack_public_path__ + "img/classroom2.4d777d74.jpg";